import React, {Component} from 'react';
import Btn from "./Btn";

class BtnSecondary extends Component {
    render() {
        const {children} = this.props;

        return (
            <Btn
                {...this.props}
                secondary
            >
                {children}
            </Btn>
        );
    };
}

export default BtnSecondary;



// WEBPACK FOOTER //
// ./src/core/admin/components/UI/BtnSecondary.js